// generated with @7nohe/openapi-react-query-codegen@0.5.3
import {
  useMutation,
  UseMutationOptions,
  useQuery,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'

import { BulkInit } from '../requests/models/BulkInit'
import { FirebaseTokenFull } from '../requests/models/FirebaseTokenFull'
import { PatchedWaitingNotificationFull } from '../requests/models/PatchedWaitingNotificationFull'
import { PhoneNumber } from '../requests/models/PhoneNumber'
import { ProcessedNotificationList } from '../requests/models/ProcessedNotificationList'
import { SQLReadNotification } from '../requests/models/SQLReadNotification'

import { TemplateFull } from '../requests/models/TemplateFull'
import { UpdateUser } from '../requests/models/UpdateUser'
import { UpsertWaitingNotifications } from '../requests/models/UpsertWaitingNotifications'
import { WaitingNotificationFull } from '../requests/models/WaitingNotificationFull'
import { WaitingNotificationsBulk } from '../requests/models/WaitingNotificationsBulk'
import { CommonService } from '../requests/services/CommonService'
import { NotificationService } from '../requests/services/NotificationService'
import { SchemaService } from '../requests/services/SchemaService'
import { TemplateService } from '../requests/services/TemplateService'
import { UsersService } from '../requests/services/UsersService'
export type UsersServiceUsersFirebaseTokenCreateMutationResult = Awaited<
  ReturnType<typeof UsersService.usersFirebaseTokenCreate>
>
export const useUsersServiceUsersFirebaseTokenCreate = <
  TData = UsersServiceUsersFirebaseTokenCreateMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: FirebaseTokenFull
      },
      TContext
    >,
    'mutationFn'
  >
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: FirebaseTokenFull
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      UsersService.usersFirebaseTokenCreate(
        requestBody
      ) as unknown as Promise<TData>,
    ...options
  })
export type UsersServiceUsersFirebaseTokenDestroyMutationResult = Awaited<
  ReturnType<typeof UsersService.usersFirebaseTokenDestroy>
>
export const useUsersServiceUsersFirebaseTokenDestroy = <
  TData = UsersServiceUsersFirebaseTokenDestroyMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<TData, TError, void, TContext>,
    'mutationFn'
  >
) =>
  useMutation<TData, TError, void, TContext>({
    mutationFn: () =>
      UsersService.usersFirebaseTokenDestroy() as unknown as Promise<TData>,
    ...options
  })
export type UsersServiceUsersUpdateSingleCreateMutationResult = Awaited<
  ReturnType<typeof UsersService.usersUpdateSingleCreate>
>
export const useUsersServiceUsersUpdateSingleCreate = <
  TData = UsersServiceUsersUpdateSingleCreateMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: UpdateUser
      },
      TContext
    >,
    'mutationFn'
  >
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: UpdateUser
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      UsersService.usersUpdateSingleCreate(
        requestBody
      ) as unknown as Promise<TData>,
    ...options
  })
export type TemplateServiceTemplateListDefaultResponse = Awaited<
  ReturnType<typeof TemplateService.templateList>
>
export type TemplateServiceTemplateListQueryResult<
  TData = TemplateServiceTemplateListDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>
export const useTemplateServiceTemplateListKey = 'TemplateServiceTemplateList'
export const useTemplateServiceTemplateList = <
  TData = TemplateServiceTemplateListDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[]
>(
  {
    limit,
    offset
  }: {
    limit?: number
    offset?: number
  },
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<TData, TError>,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery<TData, TError>({
    queryKey: [
      useTemplateServiceTemplateListKey,
      ...(queryKey ?? [{ limit, offset }])
    ],
    queryFn: () => TemplateService.templateList(limit, offset) as TData,
    ...options
  })
export type TemplateServiceTemplateCreateMutationResult = Awaited<
  ReturnType<typeof TemplateService.templateCreate>
>
export const useTemplateServiceTemplateCreate = <
  TData = TemplateServiceTemplateCreateMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: TemplateFull
      },
      TContext
    >,
    'mutationFn'
  >
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: TemplateFull
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TemplateService.templateCreate(requestBody) as unknown as Promise<TData>,
    ...options
  })
export type TemplateServiceTemplateRetrieveDefaultResponse = Awaited<
  ReturnType<typeof TemplateService.templateRetrieve>
>
export type TemplateServiceTemplateRetrieveQueryResult<
  TData = TemplateServiceTemplateRetrieveDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>
export const useTemplateServiceTemplateRetrieveKey =
  'TemplateServiceTemplateRetrieve'
export const useTemplateServiceTemplateRetrieve = <
  TData = TemplateServiceTemplateRetrieveDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[]
>(
  {
    id
  }: {
    id: number
  },
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<TData, TError>,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery<TData, TError>({
    queryKey: [
      useTemplateServiceTemplateRetrieveKey,
      ...(queryKey ?? [{ id }])
    ],
    queryFn: () => TemplateService.templateRetrieve(id) as TData,
    ...options
  })
export type TemplateServiceTemplateUpdateMutationResult = Awaited<
  ReturnType<typeof TemplateService.templateUpdate>
>
export const useTemplateServiceTemplateUpdate = <
  TData = TemplateServiceTemplateUpdateMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        id: number
        requestBody: TemplateFull
      },
      TContext
    >,
    'mutationFn'
  >
) =>
  useMutation<
    TData,
    TError,
    {
      id: number
      requestBody: TemplateFull
    },
    TContext
  >({
    mutationFn: ({ id, requestBody }) =>
      TemplateService.templateUpdate(
        id,
        requestBody
      ) as unknown as Promise<TData>,
    ...options
  })
export type TemplateServiceTemplateDestroyMutationResult = Awaited<
  ReturnType<typeof TemplateService.templateDestroy>
>
export const useTemplateServiceTemplateDestroy = <
  TData = TemplateServiceTemplateDestroyMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        id: number
      },
      TContext
    >,
    'mutationFn'
  >
) =>
  useMutation<
    TData,
    TError,
    {
      id: number
    },
    TContext
  >({
    mutationFn: ({ id }) =>
      TemplateService.templateDestroy(id) as unknown as Promise<TData>,
    ...options
  })
export type TemplateServiceTemplateInitCreateMutationResult = Awaited<
  ReturnType<typeof TemplateService.templateInitCreate>
>
/**
 * Bulk get or create  from apps
 */
export const useTemplateServiceTemplateInitCreate = <
  TData = TemplateServiceTemplateInitCreateMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: BulkInit
      },
      TContext
    >,
    'mutationFn'
  >
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: BulkInit
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      TemplateService.templateInitCreate(
        requestBody
      ) as unknown as Promise<TData>,
    ...options
  })
export type SchemaServiceSchemaRetrieveDefaultResponse = Awaited<
  ReturnType<typeof SchemaService.schemaRetrieve>
>
export type SchemaServiceSchemaRetrieveQueryResult<
  TData = SchemaServiceSchemaRetrieveDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>
export const useSchemaServiceSchemaRetrieveKey = 'SchemaServiceSchemaRetrieve'
/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const useSchemaServiceSchemaRetrieve = <
  TData = SchemaServiceSchemaRetrieveDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[]
>(
  {
    format,
    lang
  }: {
    format?: 'json' | 'yaml'
    lang?: 'en' | 'ro' | 'ru'
  },
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<TData, TError>,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery<TData, TError>({
    queryKey: [
      useSchemaServiceSchemaRetrieveKey,
      ...(queryKey ?? [{ format, lang }])
    ],
    queryFn: () => SchemaService.schemaRetrieve(format, lang) as TData,
    ...options
  })
export type NotificationServiceNotificationCountRetrieveDefaultResponse =
  Awaited<ReturnType<typeof NotificationService.notificationCountRetrieve>>
export type NotificationServiceNotificationCountRetrieveQueryResult<
  TData = NotificationServiceNotificationCountRetrieveDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>
export const useNotificationServiceNotificationCountRetrieveKey =
  'NotificationServiceNotificationCountRetrieve'
export const useNotificationServiceNotificationCountRetrieve = <
  TData = NotificationServiceNotificationCountRetrieveDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[]
>(
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<TData, TError>,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery<TData, TError>({
    queryKey: [
      useNotificationServiceNotificationCountRetrieveKey,
      ...(queryKey ?? [])
    ],
    queryFn: () => NotificationService.notificationCountRetrieve() as TData,
    ...options
  })
export type NotificationServiceNotificationDeleteUserCreateMutationResult =
  Awaited<ReturnType<typeof NotificationService.notificationDeleteUserCreate>>
export const useNotificationServiceNotificationDeleteUserCreate = <
  TData = NotificationServiceNotificationDeleteUserCreateMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: PhoneNumber
      },
      TContext
    >,
    'mutationFn'
  >
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: PhoneNumber
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NotificationService.notificationDeleteUserCreate(
        requestBody
      ) as unknown as Promise<TData>,
    ...options
  })
export type NotificationServiceNotificationItemsListDefaultResponse = Awaited<
  ReturnType<typeof NotificationService.notificationItemsList>
>
export type NotificationServiceNotificationItemsListQueryResult<
  TData = NotificationServiceNotificationItemsListDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>
export const useNotificationServiceNotificationItemsListKey =
  'NotificationServiceNotificationItemsList'
export const useNotificationServiceNotificationItemsList = <
  TData = NotificationServiceNotificationItemsListDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[]
>(
  {
    categories,
    categoryPrefix,
    deliveryMethod,
    email,
    ordering,
    page,
    perPage,
    search,
    status,
    user
  }: {
    categories?: string
    categoryPrefix?: string
    deliveryMethod?: 'email' | 'internal' | 'push' | 'sms' | 'socket'
    email?: string
    ordering?: string
    page?: number
    perPage?: number
    search?: string
    status?: Array<
      'cancelled' | 'distributed' | 'failed' | 'queued' | 'waiting'
    >
    user?: string
  },
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<TData, TError>,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery<TData, TError>({
    queryKey: [
      useNotificationServiceNotificationItemsListKey,
      ...(queryKey ?? [
        {
          categories,
          categoryPrefix,
          deliveryMethod,
          email,
          ordering,
          page,
          perPage,
          search,
          status,
          user
        }
      ])
    ],
    queryFn: () =>
      NotificationService.notificationItemsList(
        categories,
        categoryPrefix,
        deliveryMethod,
        email,
        ordering,
        page,
        perPage,
        search,
        status,
        user
      ) as TData,
    ...options
  })
export type NotificationServiceNotificationItemsRetrieveDefaultResponse =
  Awaited<ReturnType<typeof NotificationService.notificationItemsRetrieve>>
export type NotificationServiceNotificationItemsRetrieveQueryResult<
  TData = NotificationServiceNotificationItemsRetrieveDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>
export const useNotificationServiceNotificationItemsRetrieveKey =
  'NotificationServiceNotificationItemsRetrieve'
export const useNotificationServiceNotificationItemsRetrieve = <
  TData = NotificationServiceNotificationItemsRetrieveDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[]
>(
  {
    id
  }: {
    id: number
  },
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<TData, TError>,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery<TData, TError>({
    queryKey: [
      useNotificationServiceNotificationItemsRetrieveKey,
      ...(queryKey ?? [{ id }])
    ],
    queryFn: () => NotificationService.notificationItemsRetrieve(id) as TData,
    ...options
  })
export type NotificationServiceNotificationItemsUpdateMutationResult = Awaited<
  ReturnType<typeof NotificationService.notificationItemsUpdate>
>
export const useNotificationServiceNotificationItemsUpdate = <
  TData = NotificationServiceNotificationItemsUpdateMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        id: number
        requestBody: ProcessedNotificationList
      },
      TContext
    >,
    'mutationFn'
  >
) =>
  useMutation<
    TData,
    TError,
    {
      id: number
      requestBody: ProcessedNotificationList
    },
    TContext
  >({
    mutationFn: ({ id, requestBody }) =>
      NotificationService.notificationItemsUpdate(
        id,
        requestBody
      ) as unknown as Promise<TData>,
    ...options
  })
export type NotificationServiceNotificationItemsDestroyMutationResult = Awaited<
  ReturnType<typeof NotificationService.notificationItemsDestroy>
>
export const useNotificationServiceNotificationItemsDestroy = <
  TData = NotificationServiceNotificationItemsDestroyMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        id: number
      },
      TContext
    >,
    'mutationFn'
  >
) =>
  useMutation<
    TData,
    TError,
    {
      id: number
    },
    TContext
  >({
    mutationFn: ({ id }) =>
      NotificationService.notificationItemsDestroy(
        id
      ) as unknown as Promise<TData>,
    ...options
  })
export type NotificationServiceNotificationItemsPrefixesRetrieveDefaultResponse =
  Awaited<
    ReturnType<typeof NotificationService.notificationItemsPrefixesRetrieve>
  >
export type NotificationServiceNotificationItemsPrefixesRetrieveQueryResult<
  TData = NotificationServiceNotificationItemsPrefixesRetrieveDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>
export const useNotificationServiceNotificationItemsPrefixesRetrieveKey =
  'NotificationServiceNotificationItemsPrefixesRetrieve'
export const useNotificationServiceNotificationItemsPrefixesRetrieve = <
  TData = NotificationServiceNotificationItemsPrefixesRetrieveDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[]
>(
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<TData, TError>,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery<TData, TError>({
    queryKey: [
      useNotificationServiceNotificationItemsPrefixesRetrieveKey,
      ...(queryKey ?? [])
    ],
    queryFn: () =>
      NotificationService.notificationItemsPrefixesRetrieve() as TData,
    ...options
  })
export type NotificationServiceNotificationItemsUnreadCountRetrieveDefaultResponse =
  Awaited<
    ReturnType<typeof NotificationService.notificationItemsUnreadCountRetrieve>
  >
export type NotificationServiceNotificationItemsUnreadCountRetrieveQueryResult<
  TData = NotificationServiceNotificationItemsUnreadCountRetrieveDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>
export const useNotificationServiceNotificationItemsUnreadCountRetrieveKey =
  'NotificationServiceNotificationItemsUnreadCountRetrieve'
export const useNotificationServiceNotificationItemsUnreadCountRetrieve = <
  TData = NotificationServiceNotificationItemsUnreadCountRetrieveDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[]
>(
  {
    categories,
    categoryPrefix,
    deliveryMethod,
    email,
    search,
    status,
    user
  }: {
    categories?: string
    categoryPrefix?: string
    deliveryMethod?: 'email' | 'internal' | 'push' | 'sms' | 'socket'
    email?: string
    search?: string
    status?: Array<
      'cancelled' | 'distributed' | 'failed' | 'queued' | 'waiting'
    >
    user?: string
  },
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<TData, TError>,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery<TData, TError>({
    queryKey: [
      useNotificationServiceNotificationItemsUnreadCountRetrieveKey,
      ...(queryKey ?? [
        {
          categories,
          categoryPrefix,
          deliveryMethod,
          email,
          search,
          status,
          user
        }
      ])
    ],
    queryFn: () =>
      NotificationService.notificationItemsUnreadCountRetrieve(
        categories,
        categoryPrefix,
        deliveryMethod,
        email,
        search,
        status,
        user
      ) as TData,
    ...options
  })
export type NotificationServiceNotificationReadCreateMutationResult = Awaited<
  ReturnType<typeof NotificationService.notificationReadCreate>
>
export const useNotificationServiceNotificationReadCreate = <
  TData = NotificationServiceNotificationReadCreateMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: SQLReadNotification
      },
      TContext
    >,
    'mutationFn'
  >
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: SQLReadNotification
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NotificationService.notificationReadCreate(
        requestBody
      ) as unknown as Promise<TData>,
    ...options
  })
export type NotificationServiceNotificationUpsertCreateMutationResult = Awaited<
  ReturnType<typeof NotificationService.notificationUpsertCreate>
>
export const useNotificationServiceNotificationUpsertCreate = <
  TData = NotificationServiceNotificationUpsertCreateMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: UpsertWaitingNotifications
      },
      TContext
    >,
    'mutationFn'
  >
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: UpsertWaitingNotifications
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NotificationService.notificationUpsertCreate(
        requestBody
      ) as unknown as Promise<TData>,
    ...options
  })
export type NotificationServiceNotificationWaitingListDefaultResponse = Awaited<
  ReturnType<typeof NotificationService.notificationWaitingList>
>
export type NotificationServiceNotificationWaitingListQueryResult<
  TData = NotificationServiceNotificationWaitingListDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>
export const useNotificationServiceNotificationWaitingListKey =
  'NotificationServiceNotificationWaitingList'
export const useNotificationServiceNotificationWaitingList = <
  TData = NotificationServiceNotificationWaitingListDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[]
>(
  {
    page,
    perPage
  }: {
    page?: number
    perPage?: number
  },
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<TData, TError>,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery<TData, TError>({
    queryKey: [
      useNotificationServiceNotificationWaitingListKey,
      ...(queryKey ?? [{ page, perPage }])
    ],
    queryFn: () =>
      NotificationService.notificationWaitingList(page, perPage) as TData,
    ...options
  })
export type NotificationServiceNotificationWaitingCreateMutationResult =
  Awaited<ReturnType<typeof NotificationService.notificationWaitingCreate>>
export const useNotificationServiceNotificationWaitingCreate = <
  TData = NotificationServiceNotificationWaitingCreateMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: WaitingNotificationFull
      },
      TContext
    >,
    'mutationFn'
  >
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: WaitingNotificationFull
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NotificationService.notificationWaitingCreate(
        requestBody
      ) as unknown as Promise<TData>,
    ...options
  })
export type NotificationServiceNotificationWaitingRetrieveDefaultResponse =
  Awaited<ReturnType<typeof NotificationService.notificationWaitingRetrieve>>
export type NotificationServiceNotificationWaitingRetrieveQueryResult<
  TData = NotificationServiceNotificationWaitingRetrieveDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>
export const useNotificationServiceNotificationWaitingRetrieveKey =
  'NotificationServiceNotificationWaitingRetrieve'
export const useNotificationServiceNotificationWaitingRetrieve = <
  TData = NotificationServiceNotificationWaitingRetrieveDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[]
>(
  {
    id
  }: {
    id: number
  },
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<TData, TError>,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery<TData, TError>({
    queryKey: [
      useNotificationServiceNotificationWaitingRetrieveKey,
      ...(queryKey ?? [{ id }])
    ],
    queryFn: () => NotificationService.notificationWaitingRetrieve(id) as TData,
    ...options
  })
export type NotificationServiceNotificationWaitingUpdateMutationResult =
  Awaited<ReturnType<typeof NotificationService.notificationWaitingUpdate>>
export const useNotificationServiceNotificationWaitingUpdate = <
  TData = NotificationServiceNotificationWaitingUpdateMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        id: number
        requestBody: WaitingNotificationFull
      },
      TContext
    >,
    'mutationFn'
  >
) =>
  useMutation<
    TData,
    TError,
    {
      id: number
      requestBody: WaitingNotificationFull
    },
    TContext
  >({
    mutationFn: ({ id, requestBody }) =>
      NotificationService.notificationWaitingUpdate(
        id,
        requestBody
      ) as unknown as Promise<TData>,
    ...options
  })
export type NotificationServiceNotificationWaitingPartialUpdateMutationResult =
  Awaited<
    ReturnType<typeof NotificationService.notificationWaitingPartialUpdate>
  >
export const useNotificationServiceNotificationWaitingPartialUpdate = <
  TData = NotificationServiceNotificationWaitingPartialUpdateMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        id: number
        requestBody?: PatchedWaitingNotificationFull
      },
      TContext
    >,
    'mutationFn'
  >
) =>
  useMutation<
    TData,
    TError,
    {
      id: number
      requestBody?: PatchedWaitingNotificationFull
    },
    TContext
  >({
    mutationFn: ({ id, requestBody }) =>
      NotificationService.notificationWaitingPartialUpdate(
        id,
        requestBody
      ) as unknown as Promise<TData>,
    ...options
  })
export type NotificationServiceNotificationWaitingDestroyMutationResult =
  Awaited<ReturnType<typeof NotificationService.notificationWaitingDestroy>>
export const useNotificationServiceNotificationWaitingDestroy = <
  TData = NotificationServiceNotificationWaitingDestroyMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        id: number
      },
      TContext
    >,
    'mutationFn'
  >
) =>
  useMutation<
    TData,
    TError,
    {
      id: number
    },
    TContext
  >({
    mutationFn: ({ id }) =>
      NotificationService.notificationWaitingDestroy(
        id
      ) as unknown as Promise<TData>,
    ...options
  })
export type NotificationServiceNotificationWaitingBulkCreateMutationResult =
  Awaited<ReturnType<typeof NotificationService.notificationWaitingBulkCreate>>
export const useNotificationServiceNotificationWaitingBulkCreate = <
  TData = NotificationServiceNotificationWaitingBulkCreateMutationResult,
  TError = unknown,
  TContext = unknown
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody: WaitingNotificationsBulk
      },
      TContext
    >,
    'mutationFn'
  >
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody: WaitingNotificationsBulk
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      NotificationService.notificationWaitingBulkCreate(
        requestBody
      ) as unknown as Promise<TData>,
    ...options
  })
export type CommonServiceCommonHealthRetrieveDefaultResponse = Awaited<
  ReturnType<typeof CommonService.commonHealthRetrieve>
>
export type CommonServiceCommonHealthRetrieveQueryResult<
  TData = CommonServiceCommonHealthRetrieveDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>
export const useCommonServiceCommonHealthRetrieveKey =
  'CommonServiceCommonHealthRetrieve'
export const useCommonServiceCommonHealthRetrieve = <
  TData = CommonServiceCommonHealthRetrieveDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[]
>(
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<TData, TError>,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery<TData, TError>({
    queryKey: [useCommonServiceCommonHealthRetrieveKey, ...(queryKey ?? [])],
    queryFn: () => CommonService.commonHealthRetrieve() as TData,
    ...options
  })
export type CommonServiceCommonProtectedRetrieveDefaultResponse = Awaited<
  ReturnType<typeof CommonService.commonProtectedRetrieve>
>
export type CommonServiceCommonProtectedRetrieveQueryResult<
  TData = CommonServiceCommonProtectedRetrieveDefaultResponse,
  TError = unknown
> = UseQueryResult<TData, TError>
export const useCommonServiceCommonProtectedRetrieveKey =
  'CommonServiceCommonProtectedRetrieve'
export const useCommonServiceCommonProtectedRetrieve = <
  TData = CommonServiceCommonProtectedRetrieveDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[]
>(
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<TData, TError>,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery<TData, TError>({
    queryKey: [useCommonServiceCommonProtectedRetrieveKey, ...(queryKey ?? [])],
    queryFn: () => CommonService.commonProtectedRetrieve() as TData,
    ...options
  })
